export function largeSegmentMatcherContext(largeSegmentName, storage) {
    return function largeSegmentMatcher(key) {
        var isInLargeSegment = storage.largeSegments ? storage.largeSegments.isInSegment(largeSegmentName, key) : false;
        return isInLargeSegment;
    };
}
